import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { getToken } from "../../features/user/UserAvatar";

export interface CreateInviteState {
  state: LoadStateInfo;
  request?: CreateInviteRequest;
  response?: InviteResponse;
}

const initialState: CreateInviteState = {
  state: notStarted(),
};

export interface CreateInviteRequest {
  targetId: string;
  permissionIds: string[];
}

export interface InviteResponse {
    code: string;

    // 	Long id;
	// String code;
	// @JsonProperty("expiration")
	// Date expiration;

	// @JsonProperty("valid")
	// int valid;

	// @JsonProperty("accepted")
	// Date accepted;

	// @JsonProperty("userId")
	// Long userId;

}

export const executeCreateInvite = createAsyncThunk(
  "executeCreateInvite",
  async (params: CreateInviteRequest, thunkAPI) => {
    console.debug(`Execute executeCreateInvite ${params.permissionIds} on target ${params.targetId}`);

    const body = {
      targetId: params.targetId,
      permissionIds: params.permissionIds,
    };

    const response = await fetch(`${getBackendUrl()}/api/user/invite/add`, {
      method: "POST",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body)
    });

    if(response.ok) {
        return await response.json() as InviteResponse;
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  },
  
);

export const createInviteSlice = createSlice({
  name: "createInviteSlice",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clean: (state) => {
      state.state = notStarted();
      state.request = undefined;
      state.response = undefined;
    },
    clearState: (state) => {
      state.state = notStarted();
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(executeCreateInvite.pending, (state, action) => {
        state.state =  loading();
        state.request = action.meta.arg;
      })
      .addCase(executeCreateInvite.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
        state.response = action.payload;
      })
      .addCase(executeCreateInvite.rejected, (state, action) => {
        state.state = error(action);
      })
    ;
    },
});

// export const {} = createInviteSlice.actions;

export const selectCreateInvite = (state: RootState) => state.createInvite;

export default createInviteSlice.reducer;
